// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3q-1";
export var standaloneTable = "_3q-0";